import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectState = (store: StoreSchema) => store.applications.state